module.exports = __webpack_public_path__ + "img/front_earth_bump.e14a0edc.jpg";